//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'App',
    mounted(){
      console.log(this.wx_maidianId)
      var head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script')
      script.type = 'text/javaScript'
      script.innerText = `var _czc = _czc || [];_czc.push(["_setAccount", ${this.wx_maidianId}]);`
      head.appendChild(script)

      const script1 = document.createElement('script')
      script1.type = 'text/javaScript';
      script1.innerText = `var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");document.write(unescape("%3Cspan id='cnzz_stat_icon_1273787537'%3E%3C/span%3E%3Cscript src='" + cnzz_protocol + "s19.cnzz.com/z_stat.php%3Fid%3D1273787537' type='text/javascript'%3E%3C/script%3E"));`
      head.appendChild(script1)
    }

    // computed: {
    //   key() {
    //    return this.$route.path + Math.random()
    //   }
    // }
  }



// WEBPACK FOOTER //
// ./src/App.vue